/* npx-panel.js: filterspalten som ett kort spår med en panel som fälls ut i sidled (Jacob 2026-10-19).
   Förlaga: arkivets Artgrid-panel (objektet PANEL i VideoAnalysGX10/gx10/index.template.html).

   Bara från 1000 px. Skriptet bygger spåret när fönstret är brett och river det när det blir smalare,
   så att telefonens och plattans låda är exakt som förut (samma DOM, samma npx-explore.js).

   Spåret: rotlänken, en knapp per grupp (details.npx-facet: Kategorier och filtren) och foten flyttas in
   i div.npx-spar, som scrollar för sig. Grupperna står kvar i DOM:en (dolda med CSS). Ett klick på en
   knapp flyttar gruppens .npx-facet__values in i panelens kropp (ramen renderas av npx-explore.liquid),
   så det är samma kryssrutor (form="npx-facets") och samma länkar. npx-explore.js lyssnar på change på
   hela sektionen och skickar formuläret direkt på datorn, precis som förut. Vid stängning flyttas
   kroppen tillbaka till sin grupp när rörelsen är klar.

   Bredden: --pw på .npx-layout (0 eller 280 px). Rutnätets kolumn och aside följer med en transition;
   npx-explore.js ResizeObserver håller kortet överst på plats under rörelsen och räknar om raderna en
   gång när bredden har stått still i 180 ms. Utan ResizeObserver skickas ett resize efter rörelsen.

   Efter ett filterval laddas sidan om (formuläret skickas). Då öppnas samma panel igen direkt, utan
   rörelse, så att flera val i samma grupp går att göra i följd (BEHALL_EFTER_FILTER). Annars är panelen
   stängd vid laddning. */
(function () {
  "use strict";
  var root = document.querySelector("[data-npx-explore]");
  if (!root) return;
  var layout = root.querySelector("[data-npx-layout]"),
    side = root.querySelector("[data-npx-side]"),
    panel = side && side.querySelector("[data-npx-panel]");
  if (!layout || !side || !panel) return;

  var titel = panel.querySelector("[data-npx-panel-titel]"),
    kropp = panel.querySelector("[data-npx-panel-kropp]"),
    kryss = panel.querySelector("[data-npx-panel-x]"),
    wide = window.matchMedia("(min-width: 1000px)"),
    reducerad = window.matchMedia("(prefers-reduced-motion: reduce)"),
    PW = 280,
    TID = 320,
    BEHALL_EFTER_FILTER = true,
    MINNE = "npx-panel-efter-filter",
    aktiv = false,
    spar = null,
    poster = [], // {rad, details, values, nyckel, namn}
    oppen = null,
    vilande = null, // posten vars kropp ligger kvar i panelen medan den stängs
    stangT = 0;

  function sattBredd(px) {
    layout.style.setProperty("--pw", px + "px");
  }
  // Utan ResizeObserver räknar npx-explore.js om raderna på window resize: skicka ett när rörelsen är klar.
  function efterRorelse() {
    if (!("ResizeObserver" in window)) window.dispatchEvent(new Event("resize"));
  }
  layout.addEventListener("transitionend", function (e) {
    if (e.target === layout && e.propertyName === "grid-template-columns") efterRorelse();
  });

  function tillbaka(p) {
    if (p && p.values && p.values.parentNode !== p.details) p.details.appendChild(p.values);
  }
  function slappVilande() {
    clearTimeout(stangT);
    stangT = 0;
    if (vilande && vilande !== oppen) tillbaka(vilande);
    vilande = null;
  }

  function oppna(p, direkt) {
    if (oppen === p) return;
    slappVilande();
    var forra = oppen;
    if (forra) {
      forra.rad.setAttribute("aria-expanded", "false");
      tillbaka(forra);
    }
    oppen = p;
    kropp.appendChild(p.values);
    kropp.scrollTop = 0;
    titel.textContent = p.namn;
    p.rad.setAttribute("aria-expanded", "true");
    panel.removeAttribute("inert");
    if (direkt) layout.classList.add("npx-layout--direkt");
    layout.classList.add("npx-layout--pop");
    sattBredd(PW);
    if (direkt) {
      void layout.offsetWidth; // läget sätts utan transition
      layout.classList.remove("npx-layout--direkt");
    } else {
      try {
        panel.focus({ preventScroll: true });
      } catch (err) {
        panel.focus();
      }
    }
    if (!forra && (direkt || reducerad.matches)) efterRorelse();
  }

  function stang(fokus, direkt) {
    var p = oppen;
    if (!p) return;
    oppen = null;
    var fokusInne = panel.contains(document.activeElement);
    p.rad.setAttribute("aria-expanded", "false");
    panel.setAttribute("inert", "");
    layout.classList.remove("npx-layout--pop");
    if (direkt) layout.classList.add("npx-layout--direkt");
    sattBredd(0);
    if (direkt || reducerad.matches) {
      tillbaka(p);
      if (direkt) {
        void layout.offsetWidth;
        layout.classList.remove("npx-layout--direkt");
      }
      efterRorelse();
    } else {
      // kroppen ligger kvar i panelen under rörelsen och flyttas hem när den är klar
      vilande = p;
      clearTimeout(stangT);
      stangT = setTimeout(slappVilande, TID + 60);
    }
    if ((fokus || fokusInne) && p.rad.isConnected) p.rad.focus({ preventScroll: true });
  }

  function vaxla(p) {
    oppen === p ? stang(true) : oppna(p);
  }

  function nyckelFor(details, values) {
    if (details.classList.contains("npx-facet--kollektioner") || details.classList.contains("npx-facet--kolls"))
      return "kategorier";
    var inp = values.querySelector("input[name]");
    return inp ? inp.name : "";
  }

  // ---- Spåret byggs och rivs ----
  function aktivera() {
    if (aktiv) return;
    aktiv = true;
    spar = document.createElement("div");
    spar.className = "npx-spar";
    side.insertBefore(spar, panel);
    Array.prototype.slice.call(side.children).forEach(function (el) {
      if (el === spar || el === panel || el.classList.contains("npx-side__head")) return;
      spar.appendChild(el);
    });
    poster = [];
    Array.prototype.forEach.call(spar.querySelectorAll(":scope > details.npx-facet"), function (d) {
      var sum = d.querySelector(":scope > summary"),
        values = d.querySelector(":scope > .npx-facet__values");
      if (!sum || !values) return;
      var kopia = sum.cloneNode(true),
        n = kopia.querySelector(".npx-facet__n");
      n && n.parentNode.removeChild(n);
      var namn = kopia.textContent.replace(/\s+/g, " ").trim(),
        rad = document.createElement("button");
      rad.type = "button";
      rad.className = "npx-spar-rad";
      rad.setAttribute("aria-expanded", "false");
      rad.setAttribute("aria-controls", panel.id);
      var l = document.createElement("span");
      l.className = "npx-spar-rad__l";
      l.textContent = namn;
      rad.appendChild(l);
      if (n) {
        var antal = n.textContent.trim();
        n.setAttribute("aria-hidden", "true");
        rad.appendChild(n);
        rad.setAttribute("aria-label", namn + ", " + antal + (document.documentElement.lang === "sv" ? " valda" : " selected"));
      }
      var chev = document.createElement("span");
      chev.className = "npx-spar-rad__chev";
      chev.setAttribute("aria-hidden", "true");
      chev.textContent = "›";
      rad.appendChild(chev);
      d.parentNode.insertBefore(rad, d);
      var p = { rad: rad, details: d, values: values, namn: namn, nyckel: nyckelFor(d, values) };
      rad.addEventListener("click", function () {
        vaxla(p);
      });
      poster.push(p);
    });
    side.classList.add("npx-side--panel");
    layout.classList.add("npx-layout--panel");
    panel.hidden = false;
    panel.setAttribute("inert", "");
  }

  function avaktivera() {
    if (!aktiv) return;
    stang(false, true);
    slappVilande();
    poster.forEach(function (p) {
      p.rad.remove();
      tillbaka(p);
    });
    poster = [];
    while (spar.firstChild) side.insertBefore(spar.firstChild, spar);
    spar.remove();
    spar = null;
    side.classList.remove("npx-side--panel");
    layout.classList.remove("npx-layout--panel", "npx-layout--pop");
    layout.style.removeProperty("--pw");
    panel.hidden = true;
    panel.removeAttribute("inert");
    aktiv = false;
  }

  function lage() {
    wide.matches ? aktivera() : avaktivera();
  }

  kryss &&
    kryss.addEventListener("click", function () {
      stang(true);
    });

  // Esc stänger panelen när fokus ligger i spalten eller ingenstans (ett fält utanför, som sökrutan, behåller sitt Esc)
  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape" || !oppen) return;
    var a = document.activeElement;
    if (!a || a === document.body || a === document.documentElement || side.contains(a)) {
      e.preventDefault();
      stang(true);
    }
  });

  // Ett filterval i panelen skickar formuläret (npx-explore.js): kom ihåg gruppen till nästa laddning, en gång.
  kropp.addEventListener("change", function (e) {
    if (!BEHALL_EFTER_FILTER || !oppen || e.target.type !== "checkbox") return;
    try {
      sessionStorage.setItem(MINNE, JSON.stringify({ k: oppen.nyckel, t: Date.now() }));
    } catch (err) {}
  });

  function aterOppna() {
    if (!BEHALL_EFTER_FILTER) return;
    var m = null;
    try {
      m = JSON.parse(sessionStorage.getItem(MINNE) || "null");
      sessionStorage.removeItem(MINNE);
    } catch (err) {}
    if (!m || !m.k || !(Date.now() - m.t < 60000) || !aktiv) return;
    for (var i = 0; i < poster.length; i++) if (poster[i].nyckel === m.k) return oppna(poster[i], true);
  }

  // Antalet valda per grupp i spåret, efter att facetterna bytts på plats (npx-pa-plats.js på startsidan, 2026-10-19).
  // Läser gruppens summary, som npx-pa-plats.js har uppdaterat. Panelen och dess kropp lämnas som de är.
  function uppdatera() {
    if (!aktiv) return;
    poster.forEach(function (p) {
      var gammal = p.rad.querySelector(".npx-facet__n"),
        ny = p.details.querySelector(":scope > summary .npx-facet__n");
      gammal && gammal.remove();
      if (!ny) return p.rad.removeAttribute("aria-label");
      var n = ny.cloneNode(true),
        antal = n.textContent.trim();
      n.setAttribute("aria-hidden", "true");
      p.rad.insertBefore(n, p.rad.querySelector(".npx-spar-rad__chev"));
      p.rad.setAttribute("aria-label", p.namn + ", " + antal + (document.documentElement.lang === "sv" ? " valda" : " selected"));
    });
  }
  window.npxPanel = { uppdatera: uppdatera };

  lage();
  aterOppna();
  wide.addEventListener ? wide.addEventListener("change", lage) : wide.addListener && wide.addListener(lage);
})();
